<template>
  <div
    @click.self="emit('close')"
    class="modal-overlay"
  >
    <div class="modal-container">
      <!-- Header -->
      <section class="modal-header">
        <button
          class="btn-back"
          @click="emit('close')"
        >
          Voltar
        </button>
      </section>

      <!-- Formulários lado a lado -->
      <section class="forms-wrapper">
        <!-- Lado Esquerdo: Membros Disponíveis -->
        <div class="form-card form-team">
          <div class="form-content">
            <h4 class="form-title">Membros Equipe(Atividade Vinculada)</h4>

            <!-- Sem membros disponíveis -->
            <section
              v-if="membros.length == 0"
              class="empty-state"
            >
              <h6 class="empty-message">
                Todos os membros do grupo da atividade estão alocados
              </h6>
            </section>

            <!-- Lista de membros disponíveis -->
            <section
              class="members-table"
              v-else
            >
              <div class="table-container">
                <!-- Cabeçalho -->
                <div class="table-header">
                  <div class="header-cell">Nome</div>
                  <div class="header-cell header-function">Função</div>
                  <div class="header-cell header-load">Índice de carga</div>
                  <div class="header-cell">Adicionar a tarefa</div>
                </div>

                <!-- Itens -->
                <div class="table-body">
                  <div
                    class="table-row"
                    :class="{ 'row-selected': membrosSelecionados[membro.id] }"
                    v-for="membro in membrosComPeso"
                    :key="membro.id"
                  >
                    <div class="table-grid">
                      <div class="cell cell-name">
                        {{ formatarEnum(membro.nome.toUpperCase()) }}
                      </div>
                      <div class="cell cell-function">
                        {{ formatarEnum(membro.funcaoMembro) }}
                      </div>
                      <div class="cell cell-load">
                        <span
                          class="load-badge"
                          :class="'load-' + membro.peso.toLowerCase()"
                        >
                          {{ formatarEnum(membro.peso) }}
                        </span>
                      </div>
                      <div class="cell cell-action">
                        <button
                          class="btn-allocate"
                          :class="{
                            'btn-allocated': membrosSelecionados[membro.id],
                          }"
                          @click="adicionarMembroArray(membro)"
                          v-if="
                            tarefa.estadoDescricao != 'CONCLUIDA' &&
                            tarefa.estadoDescricao != 'CANCELADA'
                          "
                        >
                          {{
                            membrosSelecionados[membro.id]
                              ? "Desmarcar"
                              : "Marcar"
                          }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <!-- Botão de alocar -->
            <div class="actions-footer">
              <button
                class="btn-add-members"
                @click="adicionarMembro()"
                v-if="
                  membros.length != 0 &&
                  tarefa.estadoDescricao != 'CONCLUIDA' &&
                  tarefa.estadoDescricao != 'CANCELADA' &&
                  Object.keys(membrosSelecionados).length > 0
                "
                :disabled="Object.keys(membrosSelecionados).length === 0"
              >
                Alocar membros marcados ({{
                  Object.keys(membrosSelecionados).length
                }})
              </button>
            </div>
          </div>
        </div>
        <div class="form-card form-allocated">
          <div class="allocated-header">
            <h4 class="form-title">Membros alocados</h4>
          </div>

          <div
            class="allocated-list"
            :class="{ 'list-empty': membrosAlocados.length === 0 }"
          >
            <!-- Nenhum alocado -->
            <div
              v-if="membrosAlocados.length === 0"
              class="empty-allocated"
            >
              <p>Nenhum membro alocado ainda</p>
            </div>

            <!-- Lista de alocados -->
            <div
              class="allocated-item"
              v-for="membro in membrosAlocados"
              :key="membro.id"
            >
              <div class="member-info">
                <h5 class="member-name">{{ membro.nome }}</h5>
                <p class="member-function">
                  {{ formatarEnum(membro.funcaoMembro) }}
                </p>
              </div>

              <div class="member-actions">
                <button
                  class="btn-deallocate"
                  @click.prevent="desalocarMembro(membro)"
                  v-if="
                    tarefa.estadoDescricao != 'CONCLUIDA' &&
                    tarefa.estadoDescricao != 'CANCELADA'
                  "
                >
                  Desalocar
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import tarefaService from "@/service/tarefaService";
import acaoService from "@/service/acaoService";
import { formatarEnum } from "@/utils/FormatarEntradas";

const props = defineProps({
  acaoId: String,
  tarefa: Promise,
  membros: Array,
});
const emit = defineEmits(["close"]);
const membrosComPeso = ref();
const membros = ref([]);
const tarefa = ref();
const membrosAdicionar = ref([]);
tarefa.value = props.tarefa;
const membrosSelecionados = ref({});
const membrosAlocados = ref([]);
const nomesAlocadosTarefa = ref();
const timeAtividade = ref(props.membros);

async function buscarTime() {
  try {
    const equipeAcao = await acaoService.getMembrosTime(props.acaoId);
    equipeAcao.map((membro) => {
      props.tarefa.usuariosNomes.map((userInTarefas) => {
        if (userInTarefas == membro.nome) {
          membrosAlocados.value.push(membro);
        }
      });
    });

    let nomesNormalizados = [];
    if (tarefa.value.usuariosNomes.length != 0) {
      nomesAlocadosTarefa.value = tarefa.value.usuariosNomes;
      nomesNormalizados = tarefa.value.usuariosNomes.map((nome) =>
        nome.trim().toLowerCase()
      );
    }

    if (timeAtividade.value != null) {
      const membrosFiltrados = timeAtividade.value.Membros.filter((membro) => {
        const nomeMembro = membro.nome.trim().toLowerCase();
        return !nomesNormalizados.includes(nomeMembro);
      });
      membros.value = membrosFiltrados;
    } else {
      try {
        membros.value = await acaoService.getMembrosTime(props.acaoId);
        if (nomesNormalizados.length != 0) {
          membros.value = membros.value.filter((membro) => {
            const nomeMembro = membro.nome.trim().toLowerCase();
            return !nomesNormalizados.includes(nomeMembro);
          });
        }
      } catch (error) {
        console.log(error);
      }
    }

    membrosComPeso.value = membros.value.map((membro) => ({
      ...membro,
      peso: sortearPeso(),
    }));
  } catch (error) {
    console.log(error);
  }
}

function adicionarMembroArray(membro) {
  const id = membro.id;
  if (membrosSelecionados.value[id]) {
    delete membrosSelecionados.value[id];
    membrosAdicionar.value = membrosAdicionar.value.filter((mid) => mid !== id);
  } else {
    membrosSelecionados.value[id] = {
      membro: membro,
      btn: "Desmarcar",
    };
    membrosAdicionar.value.push(id);
  }
}

async function adicionarMembro() {
  const membrosParaAlocar = Object.values(membrosSelecionados.value);
  const membrosConfirmados = [];

  for (const selecionado of membrosParaAlocar) {
    const membro = selecionado.membro;

    if (membro.peso === "PESADA") {
      const confirmar = confirm(
        `O membro ${membro.nome} já está com muitas atividades alocadas (PESADA).\nDeseja mesmo alocar?`
      );
      if (confirmar) {
        membrosConfirmados.push(membro.id);
      } else {
        delete membrosSelecionados.value[membro.id];
        membrosAdicionar.value = membrosAdicionar.value.filter(
          (id) => id !== membro.id
        );
      }
    } else {
      membrosConfirmados.push(membro.id);
    }
  }

  if (membrosConfirmados.length === 0) {
    alert("Nenhum membro foi selecionado para alocação.");
    return;
  }

  const confirmacaoGeral = confirm(
    `Deseja realmente alocar os ${membrosConfirmados.length} membro(s) restantes?`
  );
  if (!confirmacaoGeral) return;

  try {
    const response = await tarefaService.alocarTarefa(
      tarefa.value.id,
      membrosConfirmados
    );
    if (response.status >= 200 && response.status < 300) {
      alert("Membros alocados com sucesso!");
      emit("close");
    }
  } catch (error) {
    console.log(error);
  }
}

async function desalocarMembro(membro) {
  const response = confirm(
    `Deseja desalocar ${membro.nome} da tarefa ${tarefa.value.titulo}`
  );
  if (response) {
    const payload = [
      {
        emailMembros: membro.email,
      },
    ];

    await tarefaService
      .desalocarMembroTarefa(tarefa.value.id, payload)
      .then(() => emit("close"));
  }
}

function sortearPeso() {
  const pesos = ["LEVE", "INTERMEDIARIA", "PESADA"];
  const embaralhado = pesos.sort(() => Math.random() - 0.5);
  return embaralhado[0];
}

onMounted(() => {
  buscarTime();
});
</script>

<style scoped>
/* ========================================
   OVERLAY E CONTAINER PRINCIPAL
======================================== */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: hsla(0, 0%, 0%, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
  box-sizing: border-box;
}

.modal-container {
  width: 100%;
  max-width: 1400px;
  display: flex;
  flex-direction: column;
  background-color: transparent;
}

/* ========================================
   HEADER COM BOTÃO VOLTAR
======================================== */
.modal-header {
  display: flex;
  justify-content: center;
}

.btn-back {
  background-color: var(--roxo-superficie);
  color: var(--roxo-primario);
  border: none;
  border-radius: 0.5rem 0.5rem 0 0;
  padding: 10px 30px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 150px;
}

.btn-back:hover {
  background-color: var(--roxo-claro);
}

/* ========================================
   WRAPPER DOS FORMULÁRIOS
======================================== */
.forms-wrapper {
  display: flex;
  gap: 20px;
  height: 70vh;
  min-height: 500px;
}

/* ========================================
   CARDS DOS FORMULÁRIOS
======================================== */
.form-card {
  background-color: var(--branco);
  border-radius: 1.5rem;
  padding: 25px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 5px 15px hsla(0, 0%, 0%, 0.1);
}

.form-team {
  flex: 3;
  overflow: hidden;
}

.form-allocated {
  flex: 2;
  overflow: hidden;
}

/* ========================================
   TÍTULO DOS FORMULÁRIOS
======================================== */
.form-title {
  width: 100%;
  border-bottom: 2px solid var(--roxo-primario);
  padding-bottom: 15px;
  text-align: center;
  margin: 0 0 20px 0;
  color: var(--roxo-primario);
  font-size: 1.4rem;
}

/* ========================================
   CONTEÚDO DO FORMULÁRIO DE EQUIPE
======================================== */
.form-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

/* ========================================
   ESTADO VAZIO
======================================== */
.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 40px;
}

.empty-message {
  color: var(--cinza-escuro);
  text-align: center;
  font-weight: normal;
  font-size: 1.1rem;
}

/* ========================================
   TABELA DE MEMBROS
======================================== */
.members-table {
  flex: 1;
  overflow: hidden;
  margin-bottom: 20px;
}

.table-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--cinza-claro);
  border-radius: 10px;
  overflow: hidden;
}

/* Cabeçalho da tabela */
.table-header {
  display: grid;
  grid-template-columns: 2fr 2fr 1.5fr 1.5fr;
  background-color: var(--roxo-primario);
  color: var(--branco);
  padding: 15px;
  font-weight: 600;
  text-align: center;
  align-items: center;
}

.header-cell {
  padding: 5px;
  font-size: 0.95rem;
}

/* Corpo da tabela */
.table-body {
  flex: 1;
  overflow-y: auto;
  max-height: 350px;
}

.table-row {
  border-bottom: 1px solid var(--cinza-claro);
  transition: background-color 0.2s ease;
}

.table-row:hover {
  background-color: var(--roxo-superficie);
}

.table-row.row-selected {
  background-color: var(--roxo-superficie);
}

.table-grid {
  display: grid;
  grid-template-columns: 2fr 2fr 1.5fr 1.5fr;
  padding: 15px;
  align-items: center;
}

.cell {
  padding: 5px 10px;
  text-align: center;
}

.cell-name {
  font-weight: 600;
  color: var(--cinza-escuro);
  text-align: left;
  padding-left: 20px;
}

.cell-function {
  color: var(--cinza-escuro);
}

/* ========================================
   BADGES DE CARGA
======================================== */
.load-badge {
  display: inline-block;
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
}

.load-badge.load-leve {
  background-color: var(--verde-claro);
  color: var(--verde-escuro);
}

.load-badge.load-intermediaria {
  background-color: var(--laranja-claro);
  color: var(--laranja-escuro);
}

.load-badge.load-pesada {
  background-color: var(--vermelho-claro);
  color: var(--vermelho-escuro);
}

/* ========================================
   BOTÕES DE ALOCAR
======================================== */
.btn-allocate {
  background-color: var(--roxo-primario);
  color: var(--branco);
  border: none;
  border-radius: 20px;
  padding: 8px 20px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 100px;
}

.btn-allocate:hover {
  background-color: var(--roxo-escuro);
  transform: translateY(-2px);
}

.btn-allocate.btn-allocated {
  background-color: var(--roxo-medio);
  cursor: default;
}

.btn-allocate:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* ========================================
   FOOTER DE AÇÕES
======================================== */
.actions-footer {
  display: flex;
  justify-content: center;
  padding-top: 20px;
  border-top: 1px solid var(--cinza-claro);
}

.btn-add-members {
  background-color: var(--roxo-primario);
  color: var(--branco);
  border: none;
  border-radius: 25px;
  padding: 12px 30px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-add-members:hover:not(:disabled) {
  background-color: var(--roxo-escuro);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px hsla(0, 0%, 0%, 0.2);
}

.btn-add-members:disabled {
  background-color: var(--cinza-claro);
  cursor: not-allowed;
}

/* ========================================
   MEMBROS ALOCADOS (LADO DIREITO)
======================================== */
.allocated-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 15px;
  margin-bottom: 20px;
}

.badge-counter {
  background-color: var(--roxo-medio);
  color: var(--branco);
  padding: 5px 12px;
  border-radius: 15px;
  font-size: 0.9rem;
  font-weight: 600;
}

/* Lista de alocados */
.allocated-list {
  flex: 1;
  overflow-y: auto;
  padding-right: 10px;
}

.allocated-list.list-empty {
  display: flex;
  align-items: center;
  justify-content: center;
}

.empty-allocated {
  text-align: center;
  color: var(--cinza-escuro);
  font-size: 1.1rem;
  padding: 40px;
}

.allocated-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--roxo-superficie);
  border-radius: 15px;
  padding: 15px 20px;
  margin-bottom: 15px;
  transition: all 0.3s ease;
}

.allocated-item:hover {
  background-color: var(--roxo-superficie);
  transform: translateX(5px);
}

.member-info {
  flex: 1;
}

.member-name {
  margin: 0 0 5px 0;
  color: var(--roxo-primario);
  font-size: 1.1rem;
}

.member-function {
  margin: 0;
  color: var(--cinza-escuro);
  font-size: 0.9rem;
}

/* Botão desalocar */
.btn-deallocate {
  background-color: var(--vermelho);
  color: var(--branco);
  border: none;
  border-radius: 15px;
  padding: 8px 16px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.btn-deallocate:hover {
  background-color: var(--vermelho);
  transform: translateY(-2px);
}

/* ========================================
   SCROLLBAR PERSONALIZADA
======================================== */
.table-body::-webkit-scrollbar,
.allocated-list::-webkit-scrollbar {
  width: 8px;
}

.table-body::-webkit-scrollbar-track,
.allocated-list::-webkit-scrollbar-track {
  background: var(--cinza-claro);
  border-radius: 10px;
}

.table-body::-webkit-scrollbar-thumb,
.allocated-list::-webkit-scrollbar-thumb {
  background: var(--cinza-claro);
  border-radius: 10px;
}

.table-body::-webkit-scrollbar-thumb:hover,
.allocated-list::-webkit-scrollbar-thumb:hover {
  background: var(--cinza-medio);
}

/* ========================================
   RESPONSIVIDADE - DESKTOP PEQUENO (960px - 1200px)
======================================== */
@media (max-width: 1200px) {
  .modal-container {
    max-width: 95%;
  }

  .form-card {
    padding: 20px;
  }

  .table-header,
  .table-grid {
    grid-template-columns: 2fr 1.8fr 1.3fr 1.4fr;
    padding: 12px;
  }

  .header-cell {
    font-size: 0.88rem;
  }

  .cell {
    font-size: 0.85rem;
  }

  .cell-name {
    padding-left: 15px;
  }

  .btn-allocate {
    padding: 7px 15px;
    font-size: 0.85rem;
    min-width: 85px;
  }

  .load-badge {
    font-size: 0.8rem;
    padding: 4px 10px;
  }
}

/* ========================================
   RESPONSIVIDADE - TABLETS (960px - 1024px)
======================================== */
@media (max-width: 1024px) {
  .forms-wrapper {
    gap: 15px;
  }

  .form-team {
    flex: 2.5;
  }

  .form-allocated {
    flex: 1.5;
  }

  .form-title {
    font-size: 1.2rem;
  }

  .table-header,
  .table-grid {
    grid-template-columns: 2fr 1.5fr 1.2fr 1.3fr;
    padding: 10px;
  }

  .header-cell,
  .cell {
    font-size: 0.82rem;
    padding: 4px;
  }

  .cell-name {
    padding-left: 10px;
  }

  .btn-allocate {
    padding: 6px 12px;
    font-size: 0.8rem;
    min-width: 75px;
  }

  .allocated-item {
    padding: 12px 15px;
  }

  .member-name {
    font-size: 1rem;
  }

  .member-function {
    font-size: 0.85rem;
  }
}

/* ========================================
   RESPONSIVIDADE - TABLETS MÉDIOS (até 960px)
======================================== */
@media (max-width: 960px) {
  .forms-wrapper {
    flex-direction: column;
    height: auto;
    max-height: 75vh;
    gap: 15px;
  }

  .form-team,
  .form-allocated {
    flex: none;
    max-height: none;
  }

  .form-team {
    min-height: 350px;
  }

  .form-allocated {
    min-height: 250px;
  }

  .table-header,
  .table-grid {
    grid-template-columns: 2.5fr 1.8fr 1.2fr 1.5fr;
  }

  .btn-add-members {
    padding: 10px 25px;
  }
}

/* ========================================
   RESPONSIVIDADE - TABLETS PEQUENOS (até 768px)
======================================== */
@media (max-width: 768px) {
  .modal-overlay {
    padding: 8px;
    align-items: flex-start;
    padding-top: 30px;
  }

  .modal-container {
    height: 88vh;
  }

  .btn-back {
    padding: 8px 20px;
    font-size: 0.9rem;
  }

  .form-card {
    padding: 18px;
  }

  .form-title {
    font-size: 1.15rem;
    padding-bottom: 12px;
    margin-bottom: 15px;
  }

  .form-team {
    min-height: 400px;
  }

  .form-allocated {
    min-height: 280px;
  }

  /* Ocultar coluna de função */
  .header-function,
  .cell-function {
    display: none;
  }

  .table-header,
  .table-grid {
    grid-template-columns: 2.2fr 1.2fr 1.3fr;
    padding: 12px 8px;
  }

  .header-cell {
    font-size: 0.85rem;
  }

  .cell {
    font-size: 0.82rem;
  }

  .cell-name {
    padding-left: 8px;
  }

  .btn-allocate {
    padding: 7px 14px;
    font-size: 0.8rem;
    min-width: 70px;
  }

  .load-badge {
    font-size: 0.75rem;
    padding: 4px 9px;
  }

  .btn-add-members {
    padding: 10px 20px;
    font-size: 0.9rem;
  }

  .allocated-item {
    padding: 12px 14px;
  }

  .member-name {
    font-size: 0.95rem;
  }

  .member-function {
    font-size: 0.8rem;
  }

  .btn-deallocate {
    padding: 7px 13px;
    font-size: 0.85rem;
  }
}

/* ========================================
   RESPONSIVIDADE - CELULARES GRANDES (540px - 640px)
======================================== */
@media (max-width: 640px) {
  .modal-overlay {
    padding: 5px;
    padding-top: 25px;
  }

  .btn-back {
    padding: 7px 18px;
    font-size: 0.88rem;
    min-width: 130px;
  }

  .form-card {
    padding: 15px;
    border-radius: 1.2rem;
  }

  .form-title {
    font-size: 1.1rem;
    margin-bottom: 12px;
  }

  .table-header,
  .table-grid {
    padding: 10px 6px;
  }

  .cell-name {
    padding-left: 6px;
  }

  .btn-add-members {
    width: 100%;
    padding: 11px 15px;
  }
}

/* ========================================
   RESPONSIVIDADE - CELULARES (até 540px)
======================================== */
@media (max-width: 540px) {
  .modal-overlay {
    padding: 5px;
    padding-top: 20px;
  }

  .modal-container {
    height: 92vh;
  }

  .btn-back {
    padding: 6px 16px;
    font-size: 0.85rem;
    min-width: 120px;
  }

  .form-card {
    padding: 12px;
    border-radius: 1rem;
  }

  .form-title {
    font-size: 1.05rem;
    margin-bottom: 12px;
  }

  .form-team {
    min-height: 380px;
  }

  .form-allocated {
    min-height: 260px;
  }

  /* Ocultar colunas de função e carga */
  .header-function,
  .cell-function,
  .header-load,
  .cell-load {
    display: none;
  }

  .table-header,
  .table-grid {
    grid-template-columns: 2fr 1.2fr;
    padding: 10px 5px;
  }

  .header-cell {
    font-size: 0.8rem;
  }

  .cell {
    font-size: 0.78rem;
  }

  .cell-name {
    padding-left: 5px;
  }

  .header-cell:last-child {
    text-align: center;
  }

  .btn-allocate {
    padding: 6px 12px;
    font-size: 0.78rem;
    min-width: 65px;
  }

  .allocated-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    padding: 12px;
  }

  .member-name {
    font-size: 0.92rem;
  }

  .member-function {
    font-size: 0.78rem;
  }

  .btn-deallocate {
    align-self: flex-end;
    padding: 6px 12px;
    font-size: 0.8rem;
  }

  .btn-add-members {
    width: 100%;
    padding: 10px;
    font-size: 0.88rem;
  }
}

/* ========================================
   RESPONSIVIDADE - CELULARES PEQUENOS (até 400px)
======================================== */
@media (max-width: 400px) {
  .modal-overlay {
    padding: 3px;
    padding-top: 15px;
  }

  .btn-back {
    padding: 6px 14px;
    font-size: 0.82rem;
    min-width: 110px;
  }

  .form-card {
    padding: 10px;
  }

  .form-title {
    font-size: 1rem;
    padding-bottom: 10px;
    margin-bottom: 10px;
  }

  .table-header,
  .table-grid {
    grid-template-columns: 1.8fr 1fr;
    padding: 8px 4px;
    font-size: 0.75rem;
  }

  .header-cell {
    font-size: 0.76rem;
    padding: 3px;
  }

  .cell {
    padding: 4px 5px;
    font-size: 0.75rem;
  }

  .cell-name {
    padding-left: 4px;
  }

  .btn-allocate {
    min-width: 58px;
    padding: 5px 10px;
    font-size: 0.74rem;
  }

  .actions-footer {
    padding-top: 12px;
  }

  .btn-add-members {
    padding: 9px;
    font-size: 0.82rem;
  }

  .allocated-item {
    padding: 10px;
  }

  .member-name {
    font-size: 0.88rem;
  }

  .member-function {
    font-size: 0.75rem;
  }

  .btn-deallocate {
    padding: 5px 10px;
    font-size: 0.76rem;
  }
}

/* ========================================
   RESPONSIVIDADE - TELAS MUITO PEQUENAS (até 320px)
======================================== */
@media (max-width: 320px) {
  .modal-overlay {
    padding: 2px;
    padding-top: 10px;
  }

  .btn-back {
    padding: 5px 12px;
    font-size: 0.78rem;
    min-width: 100px;
  }

  .form-card {
    padding: 8px;
  }

  .form-title {
    font-size: 0.95rem;
    padding-bottom: 8px;
  }

  .table-header,
  .table-grid {
    grid-template-columns: 1.5fr 1fr;
    padding: 6px 3px;
    font-size: 0.7rem;
  }

  .header-cell {
    font-size: 0.72rem;
    padding: 2px;
  }

  .cell {
    padding: 3px 4px;
    font-size: 0.7rem;
  }

  .cell-name {
    padding-left: 3px;
  }

  .btn-allocate {
    min-width: 52px;
    padding: 4px 8px;
    font-size: 0.7rem;
  }

  .btn-add-members {
    padding: 8px;
    font-size: 0.78rem;
  }

  .allocated-item {
    padding: 8px;
  }

  .member-name {
    font-size: 0.82rem;
  }

  .member-function {
    font-size: 0.7rem;
  }

  .btn-deallocate {
    padding: 4px 8px;
    font-size: 0.72rem;
  }
}
</style>
